// extracted by mini-css-extract-plugin
export default {"nleContainer":"whyNle_nleContainer__e9UHV","nleTextContainer":"whyNle_nleTextContainer__duGLt"};